import { Injectable } from "@angular/core";
import { ConfirmationDialogComponent } from "../widget/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { QuickHelpTourDialogComponent } from "../widget/quick-help-tour-dialog/quick-help-tour-dialog.component";
import { PdfDownloadDialogComponent } from "../widget/pdf-download-dialog/pdf-download-dialog.component";
import { EditCertificateComponent } from "../post-graduate-examination/certificate-histroy/edit-certificate/edit-certificate.component";
import { EditResearchExperienceComponent } from "../post-graduate-examination/research-experience/edit-research-experience/edit-research-experience.component";
import { EditSeniorHighEducationComponent } from "../post-graduate-examination/senior-high-education-histroy/edit-senior-high-education/edit-senior-high-education.component";
import { EditUniversityEducationComponent } from "../post-graduate-examination/university-education-histroy/edit-university-education/edit-university-education.component";
import { EditWorkExperienceComponent } from "../post-graduate-examination/work-experience-histroy/edit-work-experience/edit-work-experience.component";
import { AddEditDocumentComponent } from "../document-upload/add-edit-document/add-edit-document.component";

@Injectable({
  providedIn: "root",
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  postGraduateDialogWidth = "70%";
  openStudentResultChartDialog(courses) {
    // return this.dialog.open(StudentResultChartComponent, {
    //   disableClose: true,
    //   data: {
    //     courses: courses
    //   }
    // });
  }
  //  openForgetPasswordDialog(){
  //   return this.dialog.open(ForgetAccountComponent,{
  //      disableClose: true,
  //      data :{
  //       title : 'Forget Password'
  //      }
  //    });
  //  }
  openStudentResultSummeryChartDialog(msg) {
    // return this.dialog.open(StudentResultSummeryChartComponent, {
    //   disableClose: true,
    //   data: {
    //     message: msg
    //   }
    // });
  }
  openConfirmDialog(msg) {
    return this.dialog.open(ConfirmationDialogComponent, {
      // width: '450px',
      // panelClass: 'confirm-dialog-container',
      disableClose: true,
      // position: { top: "10%" },
      data: {
        message: msg,
      },
    });
  }
  openDownloadDialog(link) {
    return this.dialog.open(PdfDownloadDialogComponent, {
      width: "450px",
      // panelClass: 'confirm-dialog-container',
      disableClose: true,
      // position: { top: "10%" },
      data: {
        link,
      },
    });
  }
  openEditCertificateDialog(item: any) {
    return this.dialog.open(EditCertificateComponent, {
      width: this.postGraduateDialogWidth,
      disableClose: true,
      data: {
        item,
      },
    });
  }

  openEditSeniorHighEducationComponentDialog(item: any) {
    return this.dialog.open(EditSeniorHighEducationComponent, {
      width: this.postGraduateDialogWidth,
      disableClose: true,
      data: {
        item,
      },
    });
  }

  openEditResearchExperienceDialog(item: any) {
    return this.dialog.open(EditResearchExperienceComponent, {
      width: this.postGraduateDialogWidth,
      disableClose: true,
      data: {
        item,
      },
    });
  }

  openEditUniversityEducationComponentDialog(item: any) {
    return this.dialog.open(EditUniversityEducationComponent, {
      width: this.postGraduateDialogWidth,
      disableClose: true,
      data: {
        item,
      },
    });
  }

  openEditWorkExperienceComponentComponentDialog(item: any) {
    return this.dialog.open(EditWorkExperienceComponent, {
      width: this.postGraduateDialogWidth,
      disableClose: true,
      data: {
        item,
      },
    });
  }

  openAddEditDocumentComponentDialog(item: any, isNew = true) {
    return this.dialog.open(AddEditDocumentComponent, {
      width: "70%",
      disableClose: true,
      data: {
        ...item,
        isNew,
      },
    });
  }

  openAppTourDialog(data: any) {
    return this.dialog.open(QuickHelpTourDialogComponent, {
      // width: '70%',
      // height: '400px',
      panelClass: "app-tour",
      disableClose: true,
      // position: { top: "10%" },
      data: {
        data,
      },
    });
  }
}
